import { TYPE_LIMIT, TYPE_LIMIT_ACCEPT } from "@/constants";
import { TCoordinate, TDimensions, TSafariInfo, TShareData } from "@/types";
import { blob } from "stream/consumers";
import { v4 as uuidv4 } from "uuid";

// export { default as FaceUtils } from "./FaceUtils";

export const IS_PROD = process.env.REACT_APP_ENVIRONMENT === "production";

export const loadScript = (src: string, options?: any): Promise<any> => {
  return new Promise((resolve, reject) => {
    const script = document.createElement("script");
    script.src = src;
    if (options) {
      Object.keys(options).forEach((key) => {
        script.setAttribute(key, options[key]);
      });
    }
    script.onload = () => resolve(true);
    script.onerror = reject;
    document.head.appendChild(script);
  });
};

/**
 *
 * @param path
 * @returns
 */
export function withPublicPath(path: string) {
  return process.env.PUBLIC_URL + "/" + path;
}
export function withBaseUrl(path: string) {
  return process.env.REACT_APP_BASE_URL + "/" + path;
}
export const loadTiffScript = (): Promise<any> => {
  if (window["Tiff"]) {
    return Promise.resolve();
  } else {
    return loadScript(`${process.env.PUBLIC_URL}/tiff.min.js`);
  }
};

export const loadPaymentScript = (): Promise<any> => {
  if (window["Payment"]) {
    return Promise.resolve();
  } else {
    return loadScript(process.env.REACT_APP_PAYMENT_SDK!);
  }
};

export const loadLoginScript = (): Promise<any> => {
  if (window["login"]) {
    return Promise.resolve();
  } else {
    return loadScript(process.env.REACT_APP_SIGN_SDK!);
  }
};

export const loadAdsJs = () => {
  if (window["adpopup"]) {
    return Promise.resolve();
  } else {
    return loadScript(process.env.REACT_APP_AD!);
  }
};

export const scaleImage = (file: File, scale: number = 0.5): Promise<File> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.onload = (event: any) => {
      const img = new Image();

      img.onload = function () {
        const canvas = document.createElement("canvas");
        const width = img.width * scale;
        const height = img.height * scale;

        canvas.width = width;
        canvas.height = height;

        const ctx = canvas.getContext("2d");
        try {
          ctx!.drawImage(img, 0, 0, width, height);
          canvas.toBlob((blob) => {
            const scaledFile = new File([blob!], file.name, {
              type: file.type,
              lastModified: Date.now(),
            });
            resolve(scaledFile);
          }, file.type);
        } catch (err) {
          reject(err);
        }
      };

      img.onerror = reject;

      img.src = event.target.result;
    };

    reader.onerror = reject;

    reader.readAsDataURL(file);
  });
};

export const selectFile = (options?: any): Promise<File[]> => {
  return new Promise((resolve, reject) => {
    let input = document.getElementById("FOTOR_FILE_INPUT") as HTMLInputElement;
    if (!input) {
      input = document.createElement("input");
      input.type = "file";
      input.id = "FOTOR_FILE_INPUT";
      input.style.display = "none";
      document.body.append(input);
    }

    if (options) {
      Object.keys(options).forEach((key) => {
        input.setAttribute(key, options[key]);
      });
    }

    input.onchange = (e: any) => {
      document.body.removeChild(input);
      resolve(e.target.files);
    };
    input.oncancel = reject;
    input.click();
  });
};

export const getExtension = (file: File) => {
  return file.type.split("/")[1];
};

export const getCookie = (name: string) => {
  var value = "; " + document.cookie;
  var parts = value.split("; " + name + "=");
  return parts?.pop()?.split(";").shift();
  // if (parts.length === 2) {
  //   return parts.pop().split(";").shift();
  // } else if (name === "locale") {
  //   return "en_US";
  // }
};

export const setCookie = (
  name: string,
  value: string,
  expires = 60 * 60 * 24 * 30 * 1000
) => {
  let hostName = window.document.location.hostname;
  if (!["localhost", "127.0.0.1"].includes(hostName)) {
    hostName = ".fotor.com";
  }
  const exp: any = new Date();
  exp.setTime(exp.getTime() + expires);
  document.cookie =
    name +
    "=" +
    escape(value) +
    ";expires=" +
    exp.toGMTString() +
    ";path=/;domain=" +
    hostName;
};

export const getFileName = (url: string): string => {
  try {
    const urlObj = new URL(url);
    const pathname = urlObj.pathname;
    const segments = pathname.split("/");
    const fileName = segments.pop() || ""; // 获取最后一个段落作为文件名
    const prefix = "fotor-face-swap-";
    const date = new Date();
    const newTime = [
      date.getFullYear(),
      (date.getMonth() + 1 + "").padStart(2, "0"),
      (date.getDate() + "").padStart(2, "0"),
      (date.getHours() + "").padStart(2, "0"),
      (date.getMinutes() + "").padStart(2, "0"),
      (date.getSeconds() + "").padStart(2, "0"),
    ];
    const extName = fileName.split(".").pop();
    return prefix + newTime.join("") + "." + extName;
  } catch (error) {
    console.error("Invalid URL:", error);
    return "";
  }
};

export const shareToPlatForm = (
  sharePlatform: string,
  shareData: TShareData,
  noTracker?: boolean
): void => {
  const iTop = (window.screen.availHeight - 30 - 450) / 2; //获得窗口的垂直位置;
  const iLeft = (window.screen.availWidth - 10 - 650) / 2;
  const newWin: any = window.open(
    "about:blank",
    "Fotor",
    "width=650, height=450, top=" + iTop + ", left=" + iLeft
  );
  const shareUrl = encodeURIComponent(shareData.url);
  // const FBId = process.env.SERVER_ENV === 'production' ? '242107232563837' : '1643947009253606'

  let shareLink = "";
  if (!noTracker) {
    // addSensorPv.sendTracker('fotor_web$click_up$share_website', {
    //     location: window.location.href,
    //     button_position: sharePlatform,
    // })
  }
  switch (sharePlatform) {
    case "facebook": {
      shareLink = "https://www.facebook.com/sharer/sharer.php?u=" + shareUrl;
      newWin.title = "Share to Facebook";
      newWin.location.href = shareLink;
      break;
    }
    case "twitter": {
      shareLink =
        "https://twitter.com/share?source=" +
        shareUrl +
        "&url=" +
        shareUrl +
        "&text=" +
        encodeURIComponent(shareData.description ?? "");
      newWin.title = "Share to Twitter";
      newWin.location.href = shareLink;
      break;
    }
    case "tumblr": {
      shareLink =
        "https://www.tumblr.com/widgets/share/tool?shareSource=legacy&url=" +
        shareUrl +
        "&posttype=link&title=" +
        encodeURIComponent(shareData.title ?? "") +
        "&content=" +
        shareUrl;
      newWin.title = "Share to Tumblr";
      newWin.location.href = shareLink;
      break;
    }
    case "pinterest": {
      shareLink =
        "https://pinterest.com/pin/create/button/?url=" +
        shareUrl +
        "&media=" +
        shareData.thumb +
        "&description=" +
        encodeURIComponent(shareData.description ?? "");
      newWin.title = "Share to Pinterest";
      newWin.location.href = shareLink;
      break;
    }
    // case 'facebook': {
    //     shareLink = 'https://www.facebook.com/dialog/send?' + `app_id=${FBId}`
    //     shareLink += '&link=' + shareUrl
    //     shareLink += '&redirect_uri=' + shareUrl
    //     newWin.title = 'Send Facebook Message'
    //     newWin.location.href = shareLink
    //     break
    // }
    case "linkedin": {
      shareLink =
        "https://www.linkedin.com/shareArticle?mini=true&url=" + shareUrl;
      newWin.title = "Share to Linkedin";
      newWin.location.href = shareLink;
      break;
    }
  }
};

export const isValidImg = (file: File) => {
  return TYPE_LIMIT.includes(file.type);
};

export const getImgDimensions = async (
  img: File | string
): Promise<{ width: number; height: number }> => {
  let imgSrc = "";

  if (img instanceof File) {
    imgSrc = await new Promise((resolve, reject) => {
      const reader = new FileReader();

      reader.onload = (e) => {
        resolve(e.target?.result as string);
      };

      reader.onerror = (error) => {
        reject(error);
      };

      reader.readAsDataURL(img);
    });
  } else {
    imgSrc = img;
  }

  return await new Promise((resolve, reject) => {
    const imgEle = new Image();

    imgEle.onload = () => {
      resolve({ width: imgEle.width, height: imgEle.height });
    };

    imgEle.onerror = reject;

    imgEle.src = imgSrc;
  });
};

export const getOffset = (element: HTMLElement, target: HTMLElement) => {
  // 获取元素的边界矩形
  const rect = element.getBoundingClientRect();

  // 获取父元素的父元素的边界矩形
  const grandparentRect = target.getBoundingClientRect();

  // 计算相对于父元素的父元素的边界值
  const offset = {
    top: rect.top - grandparentRect.top,
    left: rect.left - grandparentRect.left,
    bottom: grandparentRect.bottom - rect.bottom,
    right: grandparentRect.right - rect.right,
  };

  return offset;
};

export const decodeUTF8 = (str: any) => {
  return str.replace(
    /(\\u)(\w{4}|\w{2})/gi,
    function ($0: any, $1: any, $2: string) {
      return String.fromCharCode(parseInt($2, 16));
    }
  );
};

export const getOldCookie = (name: string) => {
  var strCookie = document.cookie;
  var arrCookie = strCookie.split("; ");
  for (var i = 0; i < arrCookie.length; i++) {
    var arr = arrCookie[i].split("=");
    if (arr[0] === name)
      try {
        return decodeURI(decodeUTF8(arr[1]));
      } catch (e) {
        return decodeUTF8(arr[1]);
      }
  }
  return "";
};

export const getSafariInfo = (): TSafariInfo => {
  const ua = navigator.userAgent.toLowerCase();
  const isSafariBrowser =
    ua.indexOf("safari") !== -1 && ua.indexOf("chrome") === -1;
  const isMobile = /iphone|ipod|ipad/.test(ua);
  const isIpadOS =
    navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1; // For iPadOS
  return {
    isSafari: isSafariBrowser,
    isMobileSafari: isSafariBrowser && isMobile,
    isIpadSafari: isSafariBrowser && isIpadOS,
    isPcSafari: isSafariBrowser && !isMobile && !isIpadOS,
  };
};

export const sleep = (timeout: number) => {
  return new Promise((resolve) => {
    setTimeout(resolve, timeout);
  });
};

export const myBrowserOS = () => {
  let u = navigator.userAgent;
  let uLower = navigator.userAgent.toLowerCase();
  return {
    //移动终端浏览器版本信息
    ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), //ios终端
    android: u.indexOf("Android") > -1 || u.indexOf("Linux") > -1, //android终端或uc浏览器
    iPhone: u.indexOf("iPhone") > -1, //是否为iPhone或者QQHD浏览器
    mac: u.indexOf("Mac") > -1, //是否为iPhone或者QQHD浏览器
    iPad: u.indexOf("iPad") > -1, //是否iPad
    isMobile: /Android|webOS|iPhone|iPod|BlackBerry/i.test(u),
    isSafari: !!uLower.match(/version\/([\d.]+).*safari/),
    isOpera: !!uLower.match(/opera.([\d.]+)/),
    isChrome: !!uLower.match(/chrome\/([\d.]+)/),
    isFirefox: !!uLower.match(/firefox\/([\d.]+)/),
    isEdge: !!uLower.match(/edge\/([\d.]+)/),
    isIE:
      !!uLower.match(/msie ([\d.]+)/) ||
      !!uLower.match(/rv:([\d.]+)\) like gecko/),
  };
};

export const encryptWithKey = async (message: string, key: string) => {
  if (typeof window !== "undefined") {
    const { JSEncrypt } = await import("encryptlong");
    const encrypt = new JSEncrypt();
    encrypt.setPublicKey(key);
    return encrypt.encryptLong(message);
  }
  return "";
};

export const isEmpty = (value: any) => {
  if (typeof value === undefined || value === null) {
    return true;
  }
  if (typeof value === "string" && value.trim() === "") {
    return true;
  }
  if (value instanceof Array && value.length === 0) {
    return true;
  }
  if (typeof value === "object" && Object.keys(value).length === 0) {
    return true;
  }
  return false;
};

export const cropImage = (
  imageInput: File | string, // 接收 File 类型或图片地址
  x: number,
  y: number,
  width: number,
  height: number
): Promise<File> => {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.crossOrigin = "anonymous";

    // 处理 File 类型和 URL 类型的输入
    if (typeof imageInput === "string") {
      img.src = imageInput;
    } else {
      const reader = new FileReader();
      reader.onload = function (event) {
        if (event.target) {
          img.src = event.target.result as string;
        }
      };
      reader.readAsDataURL(imageInput);
    }

    img.onload = () => {
      // 创建 canvas 元素
      const canvas = document.createElement("canvas");
      const ctx = canvas.getContext("2d");

      if (!ctx) {
        reject(new Error("Canvas context not available"));
        return;
      }

      // 设置 canvas 尺寸为裁剪区域的尺寸
      canvas.width = width;
      canvas.height = height;

      // 在 canvas 上绘制裁剪区域
      ctx.drawImage(
        img,
        x,
        y,
        width,
        height, // 原图上的裁剪区域
        0,
        0,
        width,
        height // 画布上的位置与大小
      );

      // 将 canvas 转换为 Blob，并进一步转换为 File
      canvas.toBlob((blob) => {
        if (blob) {
          const file = new File([blob], "cropped_image.jpeg", {
            type: "image/jpeg",
          });
          resolve(file);
        } else {
          reject(new Error("Canvas toBlob failed"));
        }
      }, "image/jpeg");
    };

    img.onerror = (err) => {
      reject(err);
    };
  });
};

export const getRandomId = () => {
  return "CUSTOM_"+uuidv4();
};

export const expandFace = (
  originalImageDimensions: TDimensions,
  avatarCoordinate: TCoordinate,
  avatarDimensions: TDimensions
): { dimensions: TDimensions; coordinate: TCoordinate } => {
  // 按比例扩大的宽高
  const expandedWidth = avatarDimensions.width * 1.9;
  const expandedHeight = avatarDimensions.height * 1.9;

  // 新的x和y坐标，将扩展的部分平均分布在左右和上下
  const expandedX =
    avatarCoordinate.x - (expandedWidth - avatarDimensions.width) / 2;
  const expandedY = avatarCoordinate.y - avatarDimensions.height * 0.6;

  // 确保新的坐标和尺寸不超出原图的范围
  const newX = Math.max(0, expandedX);
  const newY = Math.max(0, expandedY);
  const newWidth = Math.min(
    expandedWidth,
    originalImageDimensions.width - newX
  );
  const newHeight = Math.min(
    expandedHeight,
    originalImageDimensions.height - newY
  );

  return {
    dimensions: {
      width: newWidth,
      height: newHeight,
    },
    coordinate: {
      x: newX,
      y: newY,
    },
  };
};

export const calcFaceRegion = (
  originalDimensions: TDimensions,
  faceRegion: TDimensions & TCoordinate,
  renderedDimensions: TDimensions
): {} & TDimensions & TCoordinate => {
  // 计算宽高比例
  const widthRatio = renderedDimensions.width / originalDimensions.width;
  const heightRatio = renderedDimensions.height / originalDimensions.height;

  // 计算渲染图中的脸部区域坐标和宽高
  return {
    width: faceRegion.width * widthRatio,
    height: faceRegion.height * heightRatio,
    x: faceRegion.x * widthRatio,
    y: faceRegion.y * heightRatio,
  };
};
export const checkFileSize = (file: any) => {
  if (file instanceof File) {
    return file.size <= 1024 * 1024 * 40;
  }
  return true;
};

// 判断图片尺寸
export const checkImageSize = async (file: any) => {
  if (file instanceof File) {
    const img = await imageLoader(file);
    const width = img.naturalWidth,
      height = img.naturalHeight;
    return width <= 8192 && height <= 8192;
  }
  return true;
};

export const checkType = (img: any) => {
  if (img instanceof File) {
    if (img.type) {
      return TYPE_LIMIT.includes(img.type);
    }
    const extName = (img.name.split(".").pop() || "").toLocaleLowerCase();
    return TYPE_LIMIT_ACCEPT.includes(extName);
  } else {
    return true;
  }
};
export const getFileExtension = (file: File) => {
  const lastIndex = file.name.lastIndexOf(".");
  return lastIndex !== -1
    ? file.name.substring(lastIndex + 1).toLocaleLowerCase()
    : "";
};
export const isHeic = (file: any): boolean => {
  const extName = getFileExtension(file);
  return extName === "heic" || extName === "heif";
};

export const isTiff = (file: any): boolean => {
  return file instanceof File && file.type === "image/tiff";
};

export function getStaticBaseUrl() {
  return process.env.REACT_APP_ENVIRONMENT === "production"
    ? "https://pub-static.fotor.com"
    : "https://test-pub-static.fotor.com";
  // return "https:
  //pub-static.fotor.com"
}
const changeFileName = (fileName: string, newFileName: string) => {
  if (!fileName) {
    return fileName;
  }
  fileName = fileName.toLowerCase();
  const index = fileName.lastIndexOf(".");
  if (index !== -1) {
    return fileName.slice(0, index) + newFileName;
  }
  return fileName;
};

export const imageLoader = (file: File | string) => {
  return new Promise<HTMLImageElement>((resolve, reject) => {
    const url = file instanceof File ? URL.createObjectURL(file) : file;
    const img = new Image();
    img.onload = () => {
      URL.revokeObjectURL(url);
      resolve(img);
    };
    img.onerror = () => {
      URL.revokeObjectURL(url);
      reject(new Error("Failed to load image."));
    };
    img.src = url;
    img.crossOrigin = "anonymous";
  });
};

export const converterByCanvas = (blob: File) => {
  return new Promise<File>((resolve, reject) => {
    const targetImage = new Image();
    targetImage.src = URL.createObjectURL(blob);

    targetImage.onload = function () {
      const canvas = document.createElement("canvas");
      canvas.width = targetImage.width;
      canvas.height = targetImage.height;

      const context = canvas.getContext("2d");
      if (context) {
        context.drawImage(targetImage, 0, 0);
      }

      canvas.toBlob(function (pngBlob) {
        URL.revokeObjectURL(targetImage.src);
        const file = new File(
          [pngBlob as Blob],
          // blob.name.replace(/.jpg|.jpeg|.png|.webp|.gif|/i, ".jpeg"),
          changeFileName(blob.name, ".jpeg"),
          {
            type: "image/jpeg",
          }
        );
        resolve(file);
      }, "image/jpeg");
    };

    targetImage.onerror = function () {
      // reject(new Error('Failed to load WebP image.'));
      resolve(blob);
    };
  });
};
export const isWebp = (file: any): boolean => {
  return file instanceof File && file.type === "image/webp";
};
export const webp2jpeg = (file: File): Promise<File> => {
  return new Promise((resolve, reject) => {
    imageLoader(file)
      .then((img) => {
        const canvas = document.createElement("canvas");
        canvas.width = img.width;
        canvas.height = img.height;
        const context = canvas.getContext("2d");
        if (context) {
          context.drawImage(img, 0, 0);
        }
        canvasToBlob(canvas, "image/jpeg", 1).then(blob=>{
          resolve(new File([blob as Blob], changeFileName(file.name, ".jpeg"), {
            type: "image/jpeg",
          }));
        })
      })
  });
}

export const heic2jpeg = async (file: File): Promise<File> => {
  // @ts-ignore
  if (!window["heic2any"]) {
    const baseUrl = getStaticBaseUrl();
    await loadScript(
      baseUrl + "/static/web/lib/image-converter/heic/heic2any.js"
    );
  }
  // @ts-ignore
  return window["heic2any"]({
    blob: file,
    toType: "image/jpeg",
    quality: 1,
    useWebWorker: true,
  })
    .then((result: Blob) => {
      return new File([result as Blob], changeFileName(file.name, ".jpeg"), {
        type: "image/jpeg",
      });
    })
    .catch((error: any) => {
      if (
        error.message &&
        error.message.indexOf(
          "Image is already browser readable: image/jpeg"
        ) !== -1
      ) {
        return converterByCanvas(file).then((res) => {
          return res;
        });
      }
      if (
        error.message &&
        error.message.indexOf(
          "Image is already browser readable: image/jpg"
        ) !== -1
      ) {
        return converterByCanvas(file).then((res) => {
          return res;
        });
      }
      return null;
    });
};

export const tiff2png = (file: File): Promise<File> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.onload = async (e) => {
      const buffer = e.target?.result;
      if (buffer) {
        await loadTiffScript();
        const tiff = new window["Tiff"]({ buffer });
        const canvas = tiff.toCanvas() as HTMLCanvasElement;
        canvas.toBlob((blob) => {
          if (blob) {
            const res = new File(
              [blob],
              `${file.name.substring(0, file.name.lastIndexOf(".") + 1)}.png`,
              {
                type: "image/png",
                lastModified: Date.now(),
              }
            );
            resolve(res);
          } else {
            reject(new Error("Canvas toBlob failed"));
          }
        }, "image/png");
      } else {
        reject(new Error("no buffer"));
      }
    };

    reader.onerror = reject;

    reader.readAsArrayBuffer(file);
  });
};

export const loadMobileCommonScript = () => {
  if (!myBrowserOS().isMobile) {
    return Promise.reject();
  }
  if (window["mobileCommon"]) {
    return Promise.resolve();
  } else {
    return loadScript(process.env.REACT_APP_MOBILE_COMMON_SDK!);
  }
};

export const mobileCommonSdkLoaded = (callback: (sdk: any) => void) => {
  //如果已载入立即执行
  if (window["mobileCommon"]) {
    callback && callback(window.mobileCommon);
    return () => {};
  }

  const stop = () => {
    //移除监听
    window.removeEventListener("mobile_common_sdk_loaded", loadedHandle);
  };

  const loadedHandle = () => {
    callback && callback(window.mobileCommon);
    stop();
  };

  //创建 SDK载入完成事件监听
  window.addEventListener("mobile_common_sdk_loaded", loadedHandle);

  return stop;
};

export const autoShowOpenAppConfirm = () => {
  loadMobileCommonScript()
    .then(() => {
      mobileCommonSdkLoaded(() => {
        // 第1天不展示，之后每第1、2、7天后可展示，每天只展示一次
        window.mobileCommon.scheduleTaskByTimes(
          "ai_face_swap_entry_popup_show",
          () => {
            const entryPopup = window.mobileCommon.EntryPopupInstance();
            entryPopup.show({
              projectType: "ai_face_swap",
            });
          }
        );
      });
    })
    .catch(console.error);
};

export const showDownloadSuccessResult = (imgUrl: string) => {
  loadMobileCommonScript()
    .then(() => {
      mobileCommonSdkLoaded(() => {
        const { DownloadResultPopupInstance } = window.mobileCommon;
        DownloadResultPopupInstance().show({
          bgColor: "transparent",
          projectType: "ai_face_swap",
          imgUrl,
        });
      });
    })
    .catch(console.error);
};

export const zipImg = async (file: File) => {
  const img = await imageLoader(file);
  const width = img.width,
    height = img.height;
  if (width > 2048 || height > 2048 || file.size > 5 * 1024 * 1024) {
    const blob = await compressImage(img, file.type, 2048, 5 * 1024 * 1024);
    return new File([blob], file.name, {
      type: file.type,
    });
  }
  return file;
};

export const compressImage = async (
  img: HTMLImageElement,
  fileType: string,
  maxSider: number,
  maxSize: number
) => {
  const canvas = document.createElement("canvas");
  const ctx = canvas.getContext("2d");
  if (!ctx) {
    return Promise.reject(new Error("Canvas context not available"));
  }
  let width = img.width;
  let height = img.height;
  const isVertical = width < height;
  if (isVertical) {
    height = maxSider;
    width = Math.round(height * (img.width / img.height));
  } else {
    width = maxSider;
    height = Math.round(width * (img.height / img.width));
  }
  
  canvas.width = width;
  canvas.height = height;
  ctx.drawImage(img, 0, 0, width, height);
  let newFile = await canvasToBlob(canvas, fileType);
  if (newFile.size > maxSize) {
    let quality = 0.9;
    while (newFile.size > maxSize) {
      newFile = await canvasToBlob(canvas, fileType, quality);
      quality -= 0.05;
      if(quality<0.5) {
        break;
      }
    }
  }
  releaseCanvas(canvas);

  return newFile;
};

export function canvasToBlob(
  canvas: HTMLCanvasElement,
  fileType:string,
  quality = 1
): Promise<Blob> {
  return new Promise((resolve) => {
    canvas.toBlob(
      (blob) => {
        resolve(blob as Blob);
      },
      fileType,
      quality
    );
  });
}

export function releaseCanvas(canvas: HTMLCanvasElement) {
  if (!canvas) {
    return;
  }
  if (canvas.tagName !== "CANVAS") {
    return;
  }
  canvas.width = 1;
  canvas.height = 1;
  canvas.getContext("2d")?.clearRect(0, 0, 1, 1);
}
